import { render, staticRenderFns } from "./TablePaginationInfo.vue?vue&type=template&id=f0134d3e"
import script from "./TablePaginationInfo.vue?vue&type=script&lang=js"
export * from "./TablePaginationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports